import { useParameter, useService } from 'contexts';
import { IUser } from 'interfaces';
import { useEffect, useState } from 'react';

export const useUser = () => {
  const { userService } = useService();
  const { params, token } = useParameter<{ id: string }>();

  const [user, setUser] = useState<IUser | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (params.id) {
        const response = await userService.findById(params.id);
        setUser(response);
      }
    };
    fetchData();
  }, [params.id]);

  return { user, token };
};